/**
 * CSV + download helpers.
 *
 * Extracted per docs/06-component-refactor.md §5.1 — Programs builds a
 * translations export and Copy Library builds a .md download, and both were
 * hand-rolling the same blob dance.
 *
 * The translations CSV is built here from `GET /programs` rows
 * (features/programs/translations.ts): ADR-0016 § 9 makes it a query over
 * the program list, so it reads the same data the agent does.
 */

function escapeCell(value: unknown): string {
  return `"${String(value ?? '').replace(/"/g, '""')}"`
}

/** Rows must share a shape; the first row's keys become the header order. */
export function toCsv(rows: Array<Record<string, string>>, headers?: string[]): string {
  const cols = headers ?? Object.keys(rows[0] ?? {})
  if (cols.length === 0) return ''
  return [
    cols.map(escapeCell).join(','),
    ...rows.map((row) => cols.map((c) => escapeCell(row[c])).join(',')),
  ].join('\n')
}

/** Positional rows, for a layout that is not one record per line. */
export function toCsvGrid(rows: unknown[][]): string {
  return rows.map((row) => row.map(escapeCell).join(',')).join('\n')
}

export function downloadBlob(content: string, filename: string, mime: string): void {
  const url = URL.createObjectURL(new Blob([content], { type: mime }))
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}

/** "Cardiac Rehab Intro" -> "cardiac-rehab-intro" */
export function slugify(value: string): string {
  return (
    value
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'untitled'
  )
}
